import styled from 'styled-components';

const Arrow = styled.div`
  margin-left: 0.9375rem;
  margin-bottom: -0.5rem;
  margin-top: 0.063rem;
  width: 0;
  height: 0;
  border-left: 0.375rem solid transparent;
  border-right: 0.375rem solid transparent;
  border-bottom: 0.375rem solid
    ${({ borderColor = 'currentColor' }) => borderColor};
`;

export default Arrow;
